import { render, staticRenderFns } from "./EnrollmentBase.vue?vue&type=template&id=fc80d2b4&scoped=true&"
import script from "./EnrollmentBase.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentBase.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollmentBase.vue?vue&type=style&index=0&id=fc80d2b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc80d2b4",
  null
  
)

export default component.exports